import transi from '../../../images/transi.png';


function Transition2() {
  return (
    <div className="flex flex-col items-center text-6xl m6:text-2xl i3:text-4xl i4:text-3xl">
      <span id='transition-text-1'>Planifiez et organizez</span>
      <span id='transition-text-2'>ce que vous voulez</span>
      <img className="w-44 pt-16" id='transition-pic' src={transi} alt='transitionArrow' />
    </div>
  );
}

export default Transition2;